import { ComponentType } from '@angular/cdk/portal';
import { DialogPosition } from '@angular/material/dialog';

export interface DialogOptions {
  component: ComponentType<any>;
  disableClose?: boolean;
  position?: DialogPosition;
  data?: any;
  autoFocus?: boolean;
  restoreFocus?: boolean;
  closeOnNavigation?: boolean;
  panelClass?: string;
}
